import { motion } from "framer-motion";
import Reveal from "@/components/ui/Reveal";
import { EXPERIENCE } from "@/data/portfolio";

export default function ExperienceWindow() {
  return (
    <div className="space-y-6 p-6 sm:p-7" data-testid="experience-content">
      <p className="eyebrow">tail -f experience.log</p>

      <div className="relative space-y-5 border-l border-white/10 pl-6">
        {EXPERIENCE.map((job, idx) => (
          <Reveal key={job.role} delay={idx * 0.08}>
            <article className="relative rounded-xl border border-white/8 bg-white/[.03] p-5 transition-colors duration-200 hover:bg-white/[.05]" data-testid={`experience-card-${idx}`}>
              <span
                className={`absolute -left-[27px] top-6 h-2.5 w-2.5 rounded-full border-2 border-[#0b0f17] ${job.current ? "bg-green-400 pulse-dot" : "bg-slate-500"}`}
              />
              <div className="flex flex-wrap items-baseline justify-between gap-2">
                <h3 className="font-display text-lg font-bold text-white">{job.role}</h3>
                <span className="font-mono text-[11px] text-slate-500">{job.period}</span>
              </div>
              <p className="mt-0.5 text-[13px] text-sky-300">{job.company}</p>
              <p className="font-mono text-[11px] text-slate-500">{job.location}</p>

              <div className="mt-3 flex flex-wrap gap-1.5">
                {job.chips.map((c) => (
                  <span key={c} className="rounded-md border border-sonoma/25 bg-sonoma/10 px-2 py-0.5 font-mono text-[10px] text-sky-300">
                    {c}
                  </span>
                ))}
              </div>

              <ul className="mt-3 space-y-2">
                {job.highlights.map((h, i) => (
                  <motion.li key={i} className="flex gap-2.5 text-[13px] leading-relaxed text-slate-300">
                    <span className="mt-[7px] h-1 w-1 shrink-0 rounded-full bg-sonoma" />
                    {h}
                  </motion.li>
                ))}
              </ul>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
